module.exports = __webpack_public_path__ + "media/images/btn_sign_report-db8f6e5ad71d7edcd9a0036a5e46152a.gif";